import { computed } from 'vue'
import store from '@/store'
import CapitalizationUtils from '@/utils/CapitalizationUtils'

export function useEventoImagen(props, modal) {
    const fecha_actual = computed(() => {
        const fecha = new Date()
        const fechaISO = fecha.toISOString().split('T')[0]
        const hora_actual = fecha.toTimeString().split(' ')[0]

        return `${fechaISO} ${hora_actual}`
    })

    const configuracion = computed(() => {
        return store.getters.getConfig
    })

    const teatro = computed(() => {
        return store.getters.getTeatro
    })

    const url = computed(() => {
        return window.location.href
    })

    const tieneGastosInternosOnline = computed(() => {
        if (props.event?.entradas_disponibles) {
            return props.event.entradas_disponibles.some(
                entrada => entrada.price_management_online_interno === 0
            )
        }

        return false
    })

    const toSlug = event => {
        return CapitalizationUtils.toKebabCase(event.name)
    }

    const recargarEventos = () => {
        const params = {
            filters: {
                tid: configuracion.value.hash_teatro
            }
        }

        store.dispatch(
            configuracion.vuex_alias_front_events_index,
            params
        )
    }

    const showModal = nameModal => {
        modal.show(nameModal)
    }

    const closeModal = nameModal => {
        modal.hide(nameModal)
    }

    const getLinkTo = () => {
        if (props.event?.sesiones?.length === 1) {
            return {
                name: 'front.productos.show',
                params: {
                    slug: props.event.slug,
                    sesion_id: props.event.sesiones[0].id
                }
            }
        }

        return {
            name: 'front.productos.sesiones',
            params: {
                slug: props.event.slug
            }
        }
    }

    return {
        fecha_actual,
        configuracion,
        teatro,
        url,
        tieneGastosInternosOnline,
        toSlug,
        recargarEventos,
        showModal,
        closeModal,
        getLinkTo
    }
}
